import { Button } from "@coval/ui"
import { X } from "lucide-react"

export function SofiaMessageQueue({
  messages,
  onRemove,
}: {
  messages: string[]
  onRemove: (index: number) => void
}) {
  if (!messages.length) {
    return null
  }
  return (
    <div
      className="mb-2 max-h-40 space-y-1 overflow-auto rounded-lg border border-coval-border bg-surface-2 p-2 text-sm"
      aria-label="Queued messages"
    >
      <p className="text-xs text-coval-text-muted">
        {messages.length} queued · Sent in order
      </p>
      {messages.map((text, index) => (
        <div key={index} className="flex items-center gap-2">
          <p className="min-w-0 flex-1 line-clamp-2">{text}</p>
          <Button
            icon
            variant="ghost"
            tooltip={`Remove queued message ${index + 1}`}
            onClick={() => onRemove(index)}
          >
            <X />
          </Button>
        </div>
      ))}
    </div>
  )
}
